import { hasCode } from '../../schema/widgets/ICodeWidget';
import type { Widget } from '../../schema/widgets/Widget';

/**
 * Costruisce il path completo del widget così come viene utilizzato nel form.
 */
export function getWidgetPath<W extends Widget & { id: string }>(
  widget: W,
  prefix: string | null | undefined,
) {
  const namePrefix = prefix ?? '';

  if (hasCode(widget) && widget.code) {
    return namePrefix + widget.code;
  }

  return namePrefix + widget.id;
}
